import './segmented.css';

export interface OpcaoSegmentada<T extends string | number> {
  valor: T;
  rotulo: string;
}

/**
 * Grupo de opções exclusivas, todas visíveis.
 *
 * Usa `aria-pressed` em botões, e não `role="radiogroup"`: o grupo aplica o
 * efeito no clique, sem confirmação, o que é semântica de botão de alternância.
 * Um radiogroup também obrigaria a navegação por setas, e aqui a tabulação
 * item a item é o comportamento esperado.
 *
 * `rotuloGrupo` é obrigatório: sem ele o leitor de tela anuncia três botões
 * soltos ("7 dias", "30 dias", "90 dias") sem dizer do que são período.
 */
export function Segmented<T extends string | number>({
  rotuloGrupo, opcoes, valor, onChange, disabled,
}: {
  rotuloGrupo: string;
  opcoes: ReadonlyArray<OpcaoSegmentada<T>>;
  valor: T;
  onChange: (valor: T) => void;
  disabled?: boolean;
}) {
  return (
    <div className="segmented" role="group" aria-label={rotuloGrupo}>
      {opcoes.map((opcao) => (
        <button
          key={String(opcao.valor)}
          type="button"
          className="segmented__opcao"
          aria-pressed={valor === opcao.valor}
          disabled={disabled}
          onClick={() => onChange(opcao.valor)}
        >
          {opcao.rotulo}
        </button>
      ))}
    </div>
  );
}
